<ng-http-loader [backgroundColor]="'#5f94cd'"></ng-http-loader>
<router-outlet></router-outlet>

